var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "135",
        viewBox: "0 0 178 135",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M0.0166016 133.108V0H177.167V133.108H0.0166016Z",
          fill: "#6B9603",
        },
      }),
      _c("path", {
        attrs: {
          d: "M177.166 134.259V1.15283L0 134.259H177.166Z",
          fill: "#8FB70C",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }